import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {DropdownOption} from '../../../../../models/dropdown-option.model';
import {FormControl, FormGroup} from '@angular/forms';
import {Subject, takeUntil} from 'rxjs';
import { ResourcesHubService } from '../../core/resources-hub.service';

@Component({
  selector: 'app-add-layout',
  templateUrl: './add-layout.component.html',
  styleUrls: ['./add-layout.component.css']
})
export class AddLayoutComponent implements OnInit, OnChanges, OnDestroy {
  @Input() layoutData: any;
  @Output() layoutValueChangeEmitter: EventEmitter<any> = new EventEmitter<any>()
  contentTypeOptions: DropdownOption[] = [
    {
      key: 'accordion', value: 'Accordion'
    },
    /* {
      key: 'File Attachment', value: 'File Attachment'
    }, */
    {
      key: 'google-slide', value: 'Google Slides'
    },
    {
      key: 'image', value: 'Image'
    },
    {
      key: 'text', value: 'Text'
    },
    {
      key: 'video', value: 'Video'
    }
  ]
  layoutForm: FormGroup = new FormGroup<any>(
    {
      contentType: new FormControl('')
    })
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(private resourceHubService:ResourcesHubService){}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.layoutData) {
      if (Object.keys(this.layoutData).length > 0) {
        this.layoutForm.patchValue({...this.layoutData}, {emitEvent: false})
      }
    }
  }

  ngOnInit(): void {
    this.layoutForm.valueChanges.pipe(takeUntil(this.onDestroy)).subscribe(layout => {
      this.resourceHubService.setLastUpdatedId(this.layoutData.uuid)
      this.layoutValueChangeEmitter.emit({...layout, uuid: this.layoutData.uuid})
    })
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }


}
